import { render, staticRenderFns } from "./twentyFourQReport.vue?vue&type=template&id=13dc54a1&scoped=true&lang=html"
import script from "./twentyFourQReport.vue?vue&type=script&lang=js"
export * from "./twentyFourQReport.vue?vue&type=script&lang=js"
import style0 from "./twentyFourQReport.vue?vue&type=style&index=0&id=13dc54a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc54a1",
  null
  
)

export default component.exports